import {Avatar, Image} from 'antd'
import {AppLogoSvg} from 'appConfigs/svgs/AppLogoSvg'
import classNames from 'classnames'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getAvatar from 'helpers/getAvatar'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import {useAppConfig} from 'modules/local/AppConfigContext'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useEffect, useState} from 'react'
import OrganizationContainerContext from '../OrganizationContainerContext'
import TooltipApp from "components/TooltipApp";
import {VerifiedSvg} from "../../../../components/Svgs/VerifiedSvg";
import {PhotoPlaceholderApp} from "../../../../conts/imageBase64";

const OrganizationBanner = React.memo(({Wrapper = 'div'}) => {
    const t = useTranslate()
    const {organization} = useContext(OrganizationContainerContext)
    const {isSm} = useContext(LayoutContext)

    const {org_types = {}} = useAppConfig('org_types')

    const cover_photo = _.get(organization, 'cover_photo')

    const photos = _.get(organization, 'photos', [])

    const all_photos = [cover_photo, ...photos].filter((e) => !!e)

    const org_type = _.get(org_types, _.get(organization, 'org_type') || '900')

    const verified = _.get(organization, 'certified')

    const [imageIndex, setImageIndex] = useState(0)

    const heightStyle = isSm ? '10rem' : '18rem'

    useEffect(() => {
        const interval = setInterval(() => {
            const newImageIndex = (imageIndex === all_photos.length - 1) ? 0 : (imageIndex + 1)
            setImageIndex(newImageIndex)
        }, 8000)

        return () => clearInterval(interval)
    }, [imageIndex, all_photos])

    return  (
        <Wrapper className="md:container mx-auto mb-4 flex flex-col relative">
            <div style={{ height: heightStyle }} className="w-full flex justify-end relative">
                {/* Ảnh bìa */}
                {!!all_photos.length ? (
                    <div
                        key={imageIndex}
                        style={{
                            // height: isSm ? '8rem' : '14rem',
                            objectFit: 'cover',
                            background: 'var(--background-100)',
                            backgroundImage: `url(${all_photos[imageIndex]})`,
                            backgroundSize: 'cover',
                            backgroundPosition: '50% 50%',
                        }}
                        className="w-full h-full flex justify-center blurInLeft animated object-cover rounded-b-xl shadow-md"
                    />
                ) : (
                    <Image
                        preview={false}
                        src={PhotoPlaceholderApp}
                        wrapperClassName="w-full h-full"
                        className="fadeIn animated object-cover"
                    />
                )}

                {/* Đếm số ảnh */}
                {all_photos.length > 1 && (
                    <div
                        style={{
                            background: 'rgba(0,0,0,0.1)',
                            borderBottomRightRadius: '0.5rem',
                            borderTopLeftRadius: '0.5rem',
                        }}
                        className="absolute p-1 bottom-0 right-0">
                        {all_photos.map((e, index) => (
                            <span
                                key={index}
                                onClick={() => {setImageIndex(index)}}
                                className={classNames(
                                    'mx-2 font-medium text-sm text-white italic cursor-pointer',
                                    imageIndex === index ? 'font-bold' : 'opacity-50 hover:opacity-100'
                                )}>
                                {index + 1}
                            </span>
                        ))}
                    </div>
                )}
            </div>
            <div style={{ marginTop: -40 }} className="w-95 mx-auto flex items-end gap-3 md:gap-4">
                <Avatar
                    shape="square"
                    className="rounded-xl background-200 flex flex-center z-10"
                    style={{ boxShadow: '0px 6px 10px 2px rgb(0 0 0 / 15%)', borderRadius: '0.75rem' }}
                    size={isSm ? 90 : 110}
                    icon={<AppLogoSvg size={isSm ? 50 : 60}/>}
                    src={getAvatar(organization)}
                    alt={getTitle(organization)}
                />
                <div className="flex flex-col flex-1 z-3">
                    <h1 className="font-bold text-lg md:text-2xl text-primary max-lines-1 leading-snug">
                        {getTitle(organization)}
                        {verified === 1 && (
                            <TooltipApp
                                title={t('verified')}
                                placement="right"
                                color="#87d068">
                                <VerifiedSvg
                                    size={isSm ? 16 : 20}
                                    className="ml-3"
                                />
                            </TooltipApp>
                        )}
                    </h1>
                    <span className="font-semibold text-xs text-blue-600 italic tracking-wide">
                        {t(org_type || "group")}
                    </span>
                </div>
            </div>
        </Wrapper>
    )
})

export default OrganizationBanner
